module.exports = __webpack_public_path__ + "static/media/037-cube.b82bfe67.svg";